export default {
  quickLinks: 'クイックリンク',
  support: 'サポート',
  privacyPolicy: 'プライバシーポリシー',
  termsOfService: '利用規約',
  footerDescription: 'あなたのペットケアデジタルアシスタント、愛をより温かく、ケアをより簡単に。',
  craftedWith: 'ペットへの愛を込めて開発',
  allRightsReserved: '全著作権所有',
  availableLanguages: '対応言語',
  multiLanguageSupport: '多言語サポート'
};